namespace Areas.Finance.Reports{
    "use strict";


    export function updatePublicWebsite() {
       
        let url = "/Analysis/Updates/UpdatePublicWebsite" ;
        sendRequest(url, null, 'Put');
    }

    export function updateTemporaryContractAnalysis() {

        let url = "/Analysis/Updates/CreateTempContractAnalysis";
        sendRequest(url, null, 'Put');
    }

    export function updateTemporaryContractAdvertisement() {

        let url = "/Analysis/Updates/CreateTempContractAdvertisement";
        sendRequest(url, null, 'Put');
    }

    export function updateTemporaryContractInsurance() {

        let url = "/Analysis/Updates/CreateTempContractInsurance";
        sendRequest(url, null, 'Put');
    }

    export function updateTemporaryContractPSA() {

        let url = "/Analysis/Updates/CreateTempContractPSA";
        sendRequest(url, null, 'Put');
    }

}